var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo192(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1600px",
    height: "1600px",
    viewBox: "0 0 1600 1600",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "radio-alhara-logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 946 0 946 946 0 946"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "radio-alhara-logo"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    fillRule: "nonzero",
    x: 0,
    y: 0,
    width: 1600,
    height: 1600
  }), /*#__PURE__*/React.createElement("g", {
    id: "Radio-Alhara-logo",
    transform: "translate(327.000000, 327.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-1-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.62057,20.1997278 C674.32807,20.1997278 637.022385,25.5472555 597.395496,36.3518018 C479.837478,68.4150704 356.664774,144.493617 250.581385,250.581385 C33.0057649,468.157005 -44.2290037,744.940839 78.4093851,867.587988 C201.052154,990.230753 477.840367,912.995988 695.420367,695.420367 C913.000367,477.840367 990.235131,201.052154 867.592367,78.4093851 C829.051626,39.8642649 774.380709,20.1997278 708.62057,20.1997278 M237.328626,946.000874 C166.150885,946.000874 106.579163,924.317329 64.127413,881.874336 C0.136644445,817.88357 -16.6504759,714.966654 16.86245,592.087385 C49.8410611,471.17895 127.767811,344.826635 236.299413,236.295033 C344.831015,127.767811 471.18333,49.8366815 592.087385,16.86245 C714.971033,-16.6504759 817.88795,0.132264815 881.878715,64.1230333 C945.865109,128.118182 962.652231,231.030718 929.139298,353.914367 C896.165071,474.818422 818.233941,601.175117 709.702339,709.706718 C601.175117,818.233941 474.818422,896.165071 353.914367,929.134919 C312.553145,940.416852 273.443051,946.000874 237.328626,946.000874",
    id: "Fill-1",
    fill: "#FFFFFE",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo192);
export default __webpack_public_path__ + "static/media/logo192.02dcfcb5de95a3dc4388075419efe229.svg";
export { ForwardRef as ReactComponent };